import React from 'react';
import '../../styles/pdf-cards/main.css';
import { Link } from 'react-router-dom';

const Main = () => {
    return (
        <div id='pdfCardMain'>
            <div className="pdf-card-main pt-5">
                <div className="container py-4">
                    <div className="container">
                        <h2 className="text-left my-heading">
                            Information Technology Policy-2022
                        </h2>
                        {/* <p className="text-left" style="padding-left:10px; padding-right: 35px; color:black;">Chaudhary Charan Singh University (CCSU), formerly known as Meerut University, is a renowned institution in India offering a diverse range of academic disciplines through its various pdf-card-main.</p> */}
                        <div className="row">
                            <div className="col-md-2 mb-4">
                                <a
                                    href="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2024/05/CCSU-IT-Policy.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <div className="card">
                                        <i className="fas fa-file-pdf fa-2x faculty-icons" />
                                        <h6 className="card-title">Information Technology Cell</h6>
                                    </div>
                                </a>
                            </div>
                            <div className="col-md-2 mb-4">
                                <Link to={"/activities"}>
                                    <div className="card">
                                        <i className="fas fa-file-pdf fa-2x faculty-icons" />
                                        <h6 className="card-title">Activities</h6>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;